import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useToast } from "../../../Services/ToastContext";
import { EndPoints } from "../../../Constants/endpoints";
import { useQueryClient } from "@tanstack/react-query";
import { usePostData } from "../../../hooks";
import { useTranslation } from "react-i18next";
import { GeneralSelect } from "../../../components";

interface DurationInput {
  durationTime?: number;
  isDisabled?: boolean;
  onSuccess: () => void;
  onClick?: any;
}

const options = [
  { key: 10, label: "10", value: 10 },
  { key: 15, label: "15", value: 15 },
  { key: 20, label: "20", value: 20 },
  { key: 30, label: "30", value: 30 },
  { key: 40, label: "40", value: 40 },
  { key: 50, label: "50", value: 40 },
  { key: 60, label: "60", value: 60 },
];

const Schedule: React.FC<DurationInput> = ({
  durationTime,
  onSuccess,
  isDisabled = false,
  onClick,
}) => {
  const { showToast } = useToast();
  const { mutate, isPending: isSaving } = usePostData(
    EndPoints.InspectionDuration,
  );
  const methods = useForm<DurationInput>({
    defaultValues: {
      durationTime,
    },
  });

  const { t } = useTranslation();
  const { reset } = methods;
  const queryClient = useQueryClient();

  useEffect(() => {
    if (durationTime !== undefined) {
      reset({ durationTime });
    }
  }, [durationTime, reset]);

  const handleChange = (selectedOption: any) => {
    const value = selectedOption?.value;
    if (value !== undefined) {
      const durationValue: { Duration: number } = { Duration: value };
      mutate(durationValue, {
        onSuccess: (response) => {
          if (response.Status) {
            queryClient.refetchQueries({
              queryKey: [EndPoints.GetPersonalInfo],
              exact: false,
            });
            queryClient.refetchQueries({
              queryKey: [EndPoints.GetAvailableScheduled],
              exact: false,
            });
            showToast(t("added_successfully"), "success");
            onSuccess();
          } else {
            showToast(response.ErrorMessage || "Not Added", "error");
          }
        },
        onError: (error: Error) => {
          showToast(error.message, "error");
        },
      });
    }
  };

  return (
    <div onClick={onClick}>
      <FormProvider {...methods}>
        <div className="mt-6 w-full">
          <p className="text-primary-text mb-2 text-base font-bold">
            {t("session_duration")}
          </p>
          <GeneralSelect
            name="durationTime"
            options={options}
            isClearable={false}
            isPending={isSaving}
            className="text-body-text"
            height="56px"
            placeholder={t("session_duration")}
            defaultValue={options.find(
              (option) => option.value === durationTime,
            )}
            onChange={handleChange}
            isDisabled={isDisabled}
          />
        </div>
      </FormProvider>
    </div>
  );
};

export default Schedule;
